/* eslint-disable react/no-array-index-key */
import { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { submitReviewUrl } from '../Reviews/constants';
import Fit from './Fit';
import ButtonLink from '../ButtonLink';
import css from './QuestionReviewsHeader.module.scss';
import NumericalDisplay from './NumericalDisplay';
import Rating from '../Rating';
import ViewAllPhotos from '../ViewAllPhotos';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Review = function Review(_ref) {
  var _colorways$edges$;

  var colorways = _ref.colorways,
      fitRatingAvg = _ref.fitRatingAvg,
      onViewAll = _ref.onViewAll,
      ratingAvg = _ref.ratingAvg,
      reviewCount = _ref.reviewCount,
      reviewWithPhotoCount = _ref.reviewWithPhotoCount,
      shopifyId = _ref.shopifyId,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.rating,
      children: [/*#__PURE__*/_jsxs("h3", {
        className: cc(['ada-hidden', css.title]),
        children: [title, " Reviews"]
      }), reviewCount > 0 && /*#__PURE__*/_jsx(Rating, {
        count: 5,
        size: 24,
        value: ratingAvg
      }), /*#__PURE__*/_jsxs("div", {
        className: css.counts,
        children: [/*#__PURE__*/_jsx(NumericalDisplay, {
          count: reviewCount,
          type: "Review"
        }), reviewWithPhotoCount > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            className: css.divider,
            children: "/"
          }), /*#__PURE__*/_jsx(NumericalDisplay, {
            count: reviewWithPhotoCount,
            type: "Photo"
          })]
        })]
      }), reviewWithPhotoCount > 0 && /*#__PURE__*/_jsx("div", {
        className: css.viewAllPhotos,
        children: /*#__PURE__*/_jsx(ViewAllPhotos, {
          onClick: onViewAll
        })
      })]
    }), /*#__PURE__*/_jsx(Fit, {
      colorway: colorways === null || colorways === void 0 ? void 0 : (_colorways$edges$ = colorways.edges[0]) === null || _colorways$edges$ === void 0 ? void 0 : _colorways$edges$.node,
      fitRatingAvg: fitRatingAvg,
      reviewCount: reviewCount,
      shopifyId: shopifyId
    }), /*#__PURE__*/_jsx("div", {
      className: css.feedback,
      children: /*#__PURE__*/_jsx(ButtonLink, {
        "aria-label": "Have any feedback about purchasing this product? Submit your review, here.",
        bordered: true,
        href: submitReviewUrl(shopifyId),
        children: "Write A Review"
      })
    })]
  });
};

Review.propTypes = {
  colorways: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        variantStacks: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }))
  }),
  fitRatingAvg: PropTypes.number.isRequired,
  onViewAll: PropTypes.func,
  ratingAvg: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
  reviewWithPhotoCount: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(Review);